/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Panel_Move_RightInputs */



/**
* | output |
* | --- |
* | "Move panel right" |
*
* @param {Artifact_Panel_Move_RightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_panel_move_right = /** @type {((inputs?: Artifact_Panel_Move_RightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Panel_Move_RightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Panel nach rechts verschieben")
	return /** @type {LocalizedString} */ ("Move panel right")
});